import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import cls from "./becomeSellerBanner.module.scss";
import PrimaryButton from "../button/primaryButton";

export default function BecomeSellerBanner() {
  const { t } = useTranslation();
  const { push } = useRouter();

  return (
    <div className={cls.container}>
      <div className={cls.textWrapper}>
        <h1 className={cls.title}>{t("become.seller.home.title")}</h1>
        <p className={cls.description}>{t("become.seller.home.description")}</p>
        <PrimaryButton
          fullWidth={false}
          size="large"
          onClick={() => push("/be-seller")}
        >
          {t("become.seller.home.button")}
        </PrimaryButton>
      </div>
      <div className={cls.imageWrapper} />
    </div>
  );
}
